import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export const TOKEN_KEY = "smw_token";
const LAST_ACTIVE_KEY = "smw_last_active";
const INACTIVITY_LIMIT_MS = 12 * 60 * 60 * 1000;

export const clearSession = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(LAST_ACTIVE_KEY);
};

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    const last = Number(localStorage.getItem(LAST_ACTIVE_KEY) || 0);
    if (last && Date.now() - last > INACTIVITY_LIMIT_MS) {
      clearSession();
    } else {
      config.headers.Authorization = `Bearer ${token}`;
      localStorage.setItem(LAST_ACTIVE_KEY, String(Date.now()));
    }
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401 && localStorage.getItem(TOKEN_KEY)) clearSession();
    return Promise.reject(err);
  }
);

export const formatApiError = (err, fallback = "Something went wrong. Please try again.") => {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return fallback;
};

export default api;
